<section class="dalel-page" dir="rtl">
  <div class="page-hero">
    <div class="shell">
      <p class="page-kicker">دليل بلس</p>
      <h1>الباقات</h1>
    </div>
  </div>

  <div class="page-body shell">
    <div class="plans-grid">
      <article class="plan-card" *ngFor="let plan of plans">
        <div class="plan-icon">
          <i class="fa-solid fa-shopping-cart fa-lg"></i>
        </div>
        <div class="plan-price">
          <ng-container *ngIf="plan.price === 0">مجاناً</ng-container>
          <ng-container *ngIf="plan.price !== 0">
            <span *ngIf="plan.price_before_discount" class="old">
              {{ plan.price_before_discount }} ر.س
            </span>
            {{ plan.price }} ر.س
          </ng-container>
        </div>
        <div class="plan-name">{{ plan.name }}</div>
        <div class="plan-period">{{ plan.invoice_period }} {{ plan.invoice_interval }}</div>
        <div class="plan-desc" [innerHTML]="plan.description | safeHtml"></div>
      </article>
    </div>
  </div>
</section>
